import Big from 'big.js'

export const miscalculation = (
  now: Date,
  processingTime: Date,
  passed: boolean,
) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]

  const year = processingTime.getFullYear()
  const month = processingTime.getMonth()
  const day = processingTime.getDate()
  const hours = processingTime.getHours()
  const minute = processingTime.getMinutes()
  const ago = passed ? 'ago' : ''

  if (now.getFullYear() === year && now.getMonth() === month) {
    if (now.getDate() <= day) {
      if (now.getHours() >= hours && now.getDate() === day) {
        if (now.getHours() === hours) {
          return `${now.getMinutes() - minute} min ` + ago
        }
        return `${now.getHours() - hours} hours ` + ago
      }
      return `${now.getDate() - day} days ` + ago
    }
  }
  return `${day} ${monthNames[month]} ${year}`
}

export const currentDatePeriod = (
  now: Date,
  publicStart: Date,
  privateStart: Date,
  privateEnd: Date,
) => {
  return privateStart < now
    ? privateEnd < now
      ? publicStart < now
        ? publicStart
        : privateEnd
      : privateStart
    : privateStart
}

export const poolTimeCorrectNumber = (time: any) => ({
  publicPeriod: {
    start: Number(time?.publicPoolSaleStartTime) * 1000,
    end: Number(time?.publicPoolSaleEndTime) * 1000,
  },
  privatePeriod: {
    start: Number(time?.privatePoolSaleStartTime) * 1000,
    end: Number(time?.privatePoolSaleEndTime) * 1000,
  },
})

export const currentDatePeriodForTimeLeft = (
  publicSale: { start: string | number; end: string | number },
  privateSale: { start: string | number; end: string | number },
) => {
  const publicStart = new Date(publicSale.start)
  const publicEnd = new Date(publicSale?.end)
  const privateStart = new Date(privateSale.start)
  const privateEnd = new Date(privateSale?.end)
  const now = new Date()

  return privateStart < now
    ? privateEnd < now
      ? publicStart < now
        ? publicEnd
        : publicStart
      : privateEnd
    : privateStart
}

export const nextDatePeriodForTimeLeft = (
  publicSale: { start: string | number; end: string | number },
  privateSale: { start: string | number; end: string | number },
) => {
  const publicStart = new Date(publicSale.start)
  const publicEnd = new Date(publicSale.end)
  const privateStart = new Date(privateSale.start)
  const privateEnd = new Date(privateSale.end)
  const now = new Date()

  return privateStart < now
    ? privateEnd < now
      ? publicStart < now
        ? publicEnd
        : publicStart
      : privateEnd
    : privateStart
}

export const periods = {
  upcoming: 'upcoming',
  private: 'private',
  waiting: 'waiting',
  public: 'public',
  completed: 'completed',
  comingSoon: 'comingSoon',
}

export const getStatus = (
  publicSale: { start: string | number; end: string | number },
  privateSale: { start: string | number; end: string | number },
) => {
  const publicStart = new Date(publicSale.start)
  const publicEnd = new Date(publicSale.end)
  const privateStart = new Date(privateSale.start)
  const privateEnd = new Date(privateSale.end)
  const now = new Date()

  return privateStart < now
    ? privateEnd < now
      ? publicStart < now
        ? publicEnd < now
          ? periods.completed
          : periods.public
        : periods.waiting
      : periods.private
    : periods.upcoming

  // return privateStart < now
  //   ? privateEnd < now
  //     ? publicStart < now
  //       ? publicEnd < now
  //         ? periods.completed
  //         : periods.public
  //       : periods.upcoming
  //     : periods.private
  //   : periods.upcoming;
}

export const getStatus2 = (
  publicSale: { start: string | number; end: string | number },
  privateSale: { start: string | number; end: string | number },
  totalTokensAmount: Big,
  totalPrivateSold: Big,
  totalPublicSold: Big,
  thresholdPublicAmount: Big,
) => {
  const publicStart = new Date(publicSale.start)
  const publicEnd = new Date(publicSale.end)
  const privateStart = new Date(privateSale.start)
  const privateEnd = new Date(privateSale.end)
  const now = new Date()
  if (
    (privateEnd < now &&
      new Big(totalTokensAmount)
        .minus(thresholdPublicAmount)
        .lt(totalPrivateSold)) ||
    (publicStart < now &&
      new Big(totalTokensAmount).lt(totalPrivateSold.add(totalPublicSold))) ||
    publicEnd < now
  ) {
    return periods.completed
  }
  return privateStart < now
    ? privateEnd < now
      ? publicStart < now
        ? periods.public
        : periods.waiting
      : periods.private
    : periods.upcoming
}

export const timeBeforeAfter = (
  publicSale: {
    start: number
    end: number
  },
  privateSale: {
    start: number
    end: number
  },
) => {
  const publicStart = new Date(publicSale.start)
  const privateStart = new Date(privateSale.start)
  const privateEnd = new Date(privateSale.end)
  const now = new Date()

  const period = currentDatePeriod(now, publicStart, privateStart, privateEnd)

  if (period > now) {
    return `start will be in ${miscalculation(now, period, false)}`
  } else {
    return `published ${miscalculation(now, period, true)}`
  }
}
